import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import helper from '../../../utilities/helper'
import _ from 'lodash';
import { buildUrl } from '../../../utilities/StringHelpers/StringHelpers';
import { getMyProductAsync } from './EquipmentMineAsyncThunk';

const initialState = {
    epiData: {},
    page:'',
    indexProdact: '',
    equipmentsTv: '',
    equipmentsInternet: '',
    selectTabProdact: '',
    mesError: '',
    haveTv: '',
    haveInternet:''
};

const equipmentMineSlice = createSlice({
  name: 'equipmentMinePage',
  initialState: initialState,
  reducers: {
    resetPage: (state) => initialState,
    initPage: {
      reducer: (state, action) => {
        state.epiData = action.payload.epiData;
        state.page = action.payload.page;
        state.indexProdact = action.payload.indexProdact;
      },
      prepare(action) {
        const payload = {};
        const equipmentMinePage = action.epiData;
        const epiData = {
          imageDes: equipmentMinePage.imageDes,
          imageMobile: equipmentMinePage.imageMobile,
          mainTitle: equipmentMinePage.mainTitle.value,
          secTitleTv: equipmentMinePage.secTitleTv.value,
          secTitleInternet:equipmentMinePage.secTitleInternet.value,
          linkInternet: equipmentMinePage.linkInternet.value,
          linkTv: equipmentMinePage.linkTv.value,
          questionsAndAnswersContentArea:equipmentMinePage.questionsAndAnswersContentArea,
          imageGuides: equipmentMinePage.imageGuides,
          itemsGuides: equipmentMinePage.itemsGuides,
          guidesTitle: equipmentMinePage.guidesTitle.value,
          activeTab: equipmentMinePage.activeTab.value,
          defaultImageCode: equipmentMinePage.defaultImageCode,
          defaultImage: equipmentMinePage.defaultImage,
        };
        payload.epiData = epiData;
        payload.page = 'equipmentMain';
        payload.indexProdact = epiData.activeTab ? 0 : 1;
        return { payload: payload };
      },
    },
    goToPage: (state, action) => {
   
    },
    reportDWH: (state, action) => { },
    setProdactActive:(state, action) => { 
      state.indexProdact = action.payload;
    },
    setSelectTabProdact:(state, action) => { 
      state.selectTabProdact = action.payload;
    },
    
  },
  extraReducers: {
    [getMyProductAsync.fulfilled]: (state, action) => {
      if (!action.payload) { return; }
      state.equipmentsTv = action.payload?.Body.relatedTv;
      state.equipmentsInternet = action.payload?.Body.relatedInternet;
      state.selectTabProdact = state.indexProdact === 0 ? state.equipmentsInternet : state.equipmentsTv;
      state.mesError = action.payload?.Header.ReturnCode;
      state.haveTv = action.payload?.Body.haveTv;
      state.haveInternet = action.payload?.Body.haveInternet;
    },
  },
});

export const {
  reportDWH,
  goToPage,
  initPage,
  setProdactActive,
  setSelectTabProdact
} = equipmentMineSlice.actions;


export default equipmentMineSlice.reducer;


